export default __webpack_public_path__ + "static/media/header-xl.1aa567fb.webp";